import React from 'react';
import classnames from 'classnames';
import cursorRotate from '../../../assets/svg/cursor-rotate.svg';
import styles from './cursor-icon.module.scss';

export type CursorIconProps = {
  variant: 'rotate';
} & Pick<React.HTMLAttributes<HTMLDivElement>, 'children' | 'className' | 'id'>;

export const CursorIcon: React.FC<CursorIconProps> = ({ className, id, children, variant }) => {
  const classes = classnames(styles.cursorIcon, className);

  const cursor = variant === 'rotate' ? `url(${cursorRotate}) 17 17, auto` : 'auto';

  return (
    <div className={classes} id={id} data-testid="cursor-icon-component" style={{ cursor }}>
      {children}
    </div>
  );
};

CursorIcon.displayName = 'CursorIcon';
